import { render, staticRenderFns } from "./AboutUsTeam.vue?vue&type=template&id=365f4e3c"
import script from "./AboutUsTeam.vue?vue&type=script&lang=js"
export * from "./AboutUsTeam.vue?vue&type=script&lang=js"
import style0 from "./AboutUsTeam.vue?vue&type=style&index=0&id=365f4e3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports